import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-candidate-comment-dialog',
  templateUrl: './candidate-comment-dialog.component.html',
  styleUrls: ['./candidate-comment-dialog.component.scss']
})
export class CandidateCommentDialogComponent implements OnInit {

  form: FormGroup;
  submitting: boolean = false;

  constructor(
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private http: HttpService,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<CandidateCommentDialogComponent>
  ) {

    this.form = fb.group({
      candidateId: [data.candidate.id, Validators.required],
      processListId: [data.processList.id, Validators.required],
      comment: [null, Validators.required]
    });
  }

  ngOnInit(): void {

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger } = result;
        this.submitting = trigger === 'pre';

      }
    );

    this.http.setLoadingIndicator(subject);
    this.getLeadComment();

  }

  private getLeadComment() {

    const data = this.form.getRawValue();
    this.http.get('process_list:lead_comment', data)
      .subscribe(
        (result: any) => {

          const { data } = result;
          this.form.patchValue({
            comment: data.observacao
          });
        },
        err => this.errorReport.showMessage(err)
      )

  }

  submit() {

    const data = this.form.getRawValue();

    if (this.form.valid) {


      this.http.save('process_list:lead_comment', data)
        .subscribe(
          (result: any) => {

            this.snackbar.open('Observação cadastrada com sucesso!', 'OK', { duration: 3000 });
            this.dialogRef.close();

          },
          err => {
            this.errorReport.showMessage(err);
          }
        );

    }

  }

}
